import { WEB_URL } from "@/config/endpoints";
import IMAGES from "@/public/assets/img";


export default {
  SeoContent:{
        title: 'Best Interest rate Calculator for Export Financing Trade',
        url: WEB_URL+'/interest-calculator',
        name:'description',
        description:'We provide the lowest interest rates for your export factoring trade with zero factoring fee. Calculate interest rate and get the best price for invoice financing.',
        keyword: 'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company,lowest interest rates for your export factoring,calculate interest rate', 
        imagePath:IMAGES.HOMEIMG.bigLogoNew.src
    },
  CalcIndia:true 
 
}